import React, { useState } from "react";
import { Button, Modal, Row, Col, Nav, CloseButton } from "react-bootstrap";
import TransactionSubmitted from "../Modals/TransactionSubmitted";
import Tab from "react-bootstrap/Tab";
import "./RejectConfirmModal.css";

function RejectConfirmModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="model-wraper">
        <div className="swap--button-wraper">
          <Button
            className=" swap--button w-100"
            variant="primary"
            size="lg"
            onClick={handleShow}
          >
            Confirm
          </Button>
        </div>
        <Modal
          show={show}
          onHide={handleClose}
          className="rejectconfirmation--model"
        >
          <Modal.Header>
            <div className="w-100">
              <div className="token-text">
                <h4 className="text-left">Swap Exact CAO Token</h4>
              </div>
            </div>
            <CloseButton variant="white" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex flex-column justify-content-center align-items-center swap-exact ">
              <div className="d-flex">
                <h3>0.022 CAO</h3>
              </div>
              <div className="d-flex">
                <p>$39.67</p>
              </div>
            </div>
            <div className="mb-3 tabs-confirm-reject-section">
              <Tab.Container
                id="swap-confirm-reject-tabs"
                defaultActiveKey="first"
              >
                <Row>
                  <Col sm={12}>
                    <Nav
                      variant="pills"
                      className="flex-row justify-content-center"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Detais</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Data</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <div className="d-flex justify-content-between mt-3">
                          <div className="d-flex justify-content-center align-items-center">
                            <h6>Gas fee</h6>
                            <span className="green-text">Badge</span>
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>0.000066 CAO</h5>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end gas--fee">
                          <h6>Gas fee</h6>
                        </div>
                        <div className="d-flex justify-content-between  mt-md-5 mt-3">
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>Total</h5>
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>0.022066 CAO</h5>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                          <div className="d-flex justify-content-center align-items-center gas--fee">
                            <h6>(Amount + gas fee)</h6>
                          </div>
                          <div className="d-flex justify-content-center align-items-center gas--fee">
                            <h6>$39.78</h6>
                          </div>
                        </div>
                        <div>
                          <TransactionSubmitted />
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <div className="d-flex justify-content-between mt-3">
                          <div className="d-flex justify-content-center align-items-center">
                            <h6>Gas fee</h6>
                            <span className="green-text">Badge</span>
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>0.000066 CAO</h5>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mb-3 gas--fee">
                          <h6>Gas fee</h6>
                        </div>
                        <div className="d-flex justify-content-between mt-5 mb-2">
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>Total</h5>
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>0.022066 ETH</h5>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between ">
                          <div className="d-flex justify-content-center align-items-center gas--fee">
                            <h6>(Amount + gas fee)</h6>
                          </div>
                          <div className="d-flex justify-content-center align-items-center gas--fee">
                            <h6>$39.78</h6>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default RejectConfirmModal;
